<aside class="cat__sidebar">
  <div class="search-page__sidebar-header">
    <span class="sb__header-title">Filters</span>
    @if (activeFilterCount > 0) {
      <span class="sb__active-badge">{{ activeFilterCount }} active</span>
    }
    @if (activeFilterCount > 0) {
      <button class="sb__clear-all" type="button" (click)="clearFilters()()">Clear</button>
    }
  </div>

  <!-- CAPABILITY TYPE (pills) -->
  <div class="search-page__sidebar-group">
    <div class="search-page__sidebar-group-header">
      <span class="search-page__sidebar-group-name">Asset Type</span>
      @if (filters().asset_type.length > 0) {
        <button class="search-page__sidebar-clear" type="button" (click)="clearAssetTypes()">
          Clear
        </button>
      }
    </div>
    <div class="sb__pill-row">
      @for (assetTypeDetail of assetTypeOptions(); track assetTypeDetail.value) {
        <button
          class="sb__pill"
          [class.sb__pill--active]="filters().asset_type.includes(assetTypeDetail.value)"
          type="button"
          (click)="toggleAssetType(assetTypeDetail.value)"
        >
          <ng-icon [name]="assetTypeDetail.icon" size="11px" />
          {{ assetTypeDetail.label }}
        </button>
      }
    </div>
  </div>

  <!-- TRUST STATUS -->
  <div class="search-page__sidebar-group">
    <div class="search-page__sidebar-group-header" (click)="toggleSidebarGroup('trust')">
      <span class="search-page__sidebar-group-name">Trust Status</span>
      @if (filters().trust_status.length > 0) {
        <button
          class="search-page__sidebar-clear"
          type="button"
          (click)="clearSidebarGroup('trust')"
        >
          Clear
        </button>
      }
      <svg
        class="search-page__sidebar-chevron"
        [class.search-page__sidebar-chevron--open]="sidebarGroupsExpanded().trust"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
    @if (sidebarGroupsExpanded().trust) {
      <div class="search-page__sidebar-options">
        @for (option of trustStatusOptions(); track option.key) {
          <label class="search-page__sidebar-option" [htmlFor]="'trust-' + option.key">
            <input
              type="checkbox"
              class="search-page__sidebar-checkbox"
              [id]="'trust-' + option.key"
              [checked]="filters().trust_status.includes(option.key)"
              (change)="onToggleTrustStatusOption(option.key)"
            />
            <span class="sb__opt-label">{{ option.key }}</span>
            <span class="sb__opt-count">{{ option.count }}</span>
          </label>
        }
      </div>
    }
  </div>

  <!-- ACCESS -->
  <div class="search-page__sidebar-group">
    <div class="search-page__sidebar-group-header" (click)="toggleSidebarGroup('access')">
      <span class="search-page__sidebar-group-name">Access</span>
      @if (filters().access.length > 0) {
        <button
          class="search-page__sidebar-clear"
          type="button"
          (click)="clearSidebarGroup('access')"
        >
          Clear
        </button>
      }
      <svg
        class="search-page__sidebar-chevron"
        [class.search-page__sidebar-chevron--open]="sidebarGroupsExpanded().access"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
    @if (sidebarGroupsExpanded().access) {
      <div class="search-page__sidebar-options">
        @for (option of accessOptions(); track option.key) {
          <label class="search-page__sidebar-option" [id]="'access-' + option.key">
            <input
              type="checkbox"
              class="search-page__sidebar-checkbox"
              [id]="'access-' + option.key"
              [checked]="filters().access.includes(option.key)"
              (change)="onToggleAccessOption(option.key)"
            />
            <span class="sb__opt-label">{{ option.key }}</span>
            <span class="sb__opt-count">{{ option.count }}</span>
          </label>
        }
      </div>
    }
  </div>

  <div class="search-page__sidebar-group">
    <div class="search-page__sidebar-group-header" (click)="toggleSidebarGroup('sector')">
      <span class="search-page__sidebar-group-name">Sector</span>
      @if (filters().sector.length > 0) {
        <button
          class="search-page__sidebar-clear"
          type="button"
          (click)="clearSidebarGroup('sector')"
        >
          Clear
        </button>
      }
      <svg
        class="search-page__sidebar-chevron"
        [class.search-page__sidebar-chevron--open]="sidebarGroupsExpanded().sector"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
    @if (sidebarGroupsExpanded().sector) {
      <div class="search-page__sidebar-options">
        @for (option of sectorOptions(); track option.key) {
          <label class="search-page__sidebar-option" [id]="'sector-' + option.key">
            <input
              type="checkbox"
              class="search-page__sidebar-checkbox"
              [id]="'sector-' + option.key"
              [checked]="filters().sector.includes(option.key)"
              (change)="onToggleSectorOption(option.key)"
            />
            <span class="sb__opt-label">{{ option.key }}</span>
            <span class="sb__opt-count">{{ option.count }}</span>
          </label>
        }
      </div>
    }
  </div>

  <div class="search-page__sidebar-group">
    <div class="search-page__sidebar-group-header" (click)="toggleSidebarGroup('themes')">
      <span class="search-page__sidebar-group-name">Themes</span>
      @if (filters().themes.length > 0) {
        <button
          class="search-page__sidebar-clear"
          type="button"
          (click)="clearSidebarGroup('themes')"
        >
          Clear
        </button>
      }
      <svg
        class="search-page__sidebar-chevron"
        [class.search-page__sidebar-chevron--open]="sidebarGroupsExpanded().themes"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
    @if (sidebarGroupsExpanded().themes) {
      <div class="search-page__sidebar-options">
        @for (option of themesOptions(); track option.key) {
          <label class="search-page__sidebar-option" [id]="'themes-' + option.key">
            <input
              type="checkbox"
              class="search-page__sidebar-checkbox"
              [id]="'themes-' + option.key"
              [checked]="filters().themes.includes(option.key)"
              (change)="onToggleThemesOption(option.key)"
            />
            <span class="sb__opt-label">{{ option.key }}</span>
            <span class="sb__opt-count">{{ option.count }}</span>
          </label>
        }
      </div>
    }
  </div>

  <div class="search-page__sidebar-group">
    <div class="search-page__sidebar-group-header" (click)="toggleSidebarGroup('regions')">
      <span class="search-page__sidebar-group-name">Region</span>
      @if (filters().regions.length > 0) {
        <button
          class="search-page__sidebar-clear"
          type="button"
          (click)="clearSidebarGroup('regions')"
        >
          Clear
        </button>
      }
      <svg
        class="search-page__sidebar-chevron"
        [class.search-page__sidebar-chevron--open]="sidebarGroupsExpanded().regions"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
    @if (sidebarGroupsExpanded().regions) {
      <div class="search-page__sidebar-options">
        @for (option of regionOptions(); track option.key) {
          <label class="search-page__sidebar-option" [id]="'region-' + option.key">
            <input
              type="checkbox"
              class="search-page__sidebar-checkbox"
              [id]="'region-' + option.key"
              [checked]="filters().regions.includes(option.key)"
              (change)="onToggleRegionOption(option.key)"
            />
            <span class="sb__opt-label">{{ option.key }}</span>
            <span class="sb__opt-count">{{ option.count }}</span>
          </label>
        }
      </div>
    }
  </div>
</aside>
